import styled from "styled-components";
import { theme } from '../../styles/theme';

const { colors } = theme;

export const Card = styled.div`
  width: 100%;
  max-width: 615px;
  align-self: ${props => props.left ? 'flex-start' : 'center'};
  background: ${colors.gray.Cinza_13};
  border-radius: 16px;
  margin-bottom: 14px;
  overflow: hidden;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  cursor: pointer;
`;

export const Body = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 22px 24px;
  border-top: 1px solid ${colors.gray.Cinza_11};
`;

export const BodyContent = styled.div`
  width: 100%;
  max-width: 480px;

  gap: 16px;
  display: flex;
  flex-direction: column;
`;

export const HeadTitle = styled.h3`
  font-size: 16px;
  font-weight: 800;
  color: ${colors.gray.Cinza_2};
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 4px;
  scrollbar-width: thin;
  scrollbar-color: ${colors.gray.Cinza_9} transparent;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.gray.Cinza_9};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const LogoWrap = styled.div`
  display: flex;
  flex-direction: ${props => (props.openBox ? 'collumn' : 'row')};
  justify-content: ${props => (props.openBox ? 'space-around' : 'space-between')};
  align-items: ${props => (props.openBox ? 'flex-start' : 'center')};
  border-radius: 12px;
  outline: 2px solid transparent;
  outline-offset: -2px;
  transition: outline-color 0.2s ease;

  &:hover {
    outline-color: ${theme.colors.green.Verde_AgroReceita};
  }

  padding: 0 0px;
  padding-bottom: ${props => (props.openBox ? '30px' : '0px')};


  .selectValue{
    width: 270px;
    height: 50px;
  }
`;

export const Tag = styled.span`
  font-weight: 800;
  font-size: 9px;
  letter-spacing: .08em;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 500px;
  white-space: nowrap;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;

  background: ${props => props.variant === 'conectado' ? 'rgba(88,155,255,.16)' : colors.gray.Cinza_11};
  color: ${props => props.variant === 'conectado' ? '#2f6fd1' : colors.gray.Cinza_6};

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${props => props.variant === 'conectado' ? '#2f6fd1' : colors.gray.Cinza_8};
  }
`;

export const IconBtn = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${colors.white.Branco};
  border: 1px solid ${colors.gray.Cinza_11};
  display: grid;
  place-items: center;
  cursor: pointer;
  color: ${colors.gray.Cinza_6};
  flex-shrink: 0;
  padding: 0;
  transition: all .15s;

  &:hover {
    background: ${colors.gray.Cinza_12};
    color: ${colors.gray.Cinza_2};
  }

  &.del:hover {
    color: ${colors.red.Vermelho_erro};
    border-color: ${colors.red.Vermelho_erro};
  }

  .arrow {
    transition: transform .2s;
    transform: ${props => props.open ? 'rotate(180deg)' : 'none'};
  }
`;

export const Title = styled.h2`
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${theme.colors.gray.Cinza_5};
    margin-top: ${props => props.open ? '24px' : '0px'};
    margin-bottom: ${props => props.open ? '24px' : '0px'};
`;

export const Text = styled.label`
    font-family: Lato;
    font-size: 14px;
    color: ${theme.colors.gray.Cinza_6};
    margin-bottom: 0px;
    margin-top: 10px;
`;

export const Container = styled.div`
    width: 100%;
    max-width: 400px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Status = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${props => props.status === 1 ? theme.colors.green.Verde_AgroReceita : theme.colors.red.Vermelho_erro};
  border: 1px solid transparent;
  border-radius: 50%;
  flex-shrink: 0;
`;
